/* src/app/warehousing/pages/locations/locations.component.scss */
/*# sourceMappingURL=locations.component.css.map */
